import store from "@/store";
import Vue from "vue";
import VueRouter from "vue-router";

import CreateNewUserAccount from "../views/Accounts/CreateNewUserAccount.vue";
import DemoTradingAccount from "../views/Accounts/DemoTradingAccount.vue";
import DocumentsView from "../views/Accounts/DocumentsView.vue";
import LiveTradingAccount from "../views/Accounts/LiveTradingAccount.vue";
import RegisteredUser from "../views/Accounts/RegisteredUser.vue";
import RegisteredUserDetails from "../views/Accounts/RegisteredUserDetails.vue";
import UserActivity from "../views/Accounts/UserActivity.vue";
import AdminList from "../views/Admin/AdminList.vue";
import LoginRecords from "../views/Admin/LoginRecords.vue";
import ContestView from "../views/Contest/ContestView.vue";
import FinishedContest from "../views/Contest/FinishedContest.vue";
import JoinRequest from "../views/Contest/JoinRequest.vue";
import PendingContest from "../views/Contest/PendingContest.vue";
import RunningContest from "../views/Contest/RunningContest.vue";
import DashboardView from "../views/Dashboard/DashboardView.vue";
import EmailLogs from "../views/EmailLogs/EmailLogs.vue";
import LoginView from "../views/LoginView.vue";
import InvestorsView from "../views/Mam/InvestorsView.vue";
import ManagerDetails from "../views/Mam/ManagerDetails.vue";
import ManagerStatistics from "../views/Mam/ManagerStatistics.vue";
import ManagersView from "../views/Mam/ManagersView.vue";
import InactiveAccounts from "../views/MarketingTool/InactiveAccounts.vue";
import EmailHistory from "../views/MarketingTool/EmailHistory.vue";
import ImportExcel from "../views/MarketingTool/ImportExcel.vue";
import SendEmail from "../views/MarketingTool/SendEmail.vue";
import AddNews from "../views/News/AddNews.vue";
import NewsEdit from "../views/News/NewsEdit.vue";
import NewsView from "../views/News/NewsView.vue";
import AssignAccountType from "../views/Partners/AssignAccountType.vue";
import BannerUpload from "../views/Partners/BannerUpload.vue";
import CommissionSettings from "../views/Partners/CommissionSettings.vue";
import CommissionTree from "../views/Partners/CommissionTree.vue";
import CurrencyView from "../views/Partners/CurrencyView.vue";
import LevelUnlockSettings from "../views/Partners/LevelUnlockSettings.vue";
import PartnerList from "../views/Partners/PartnerList.vue";
import PartnerListDetails from "../views/Partners/PartnerListDetails.vue";
import WithdrawRequests from "../views/Partners/WithdrawRequests.vue";
import ProfileVerify from "../views/ProfileVerify.vue";
import RmsGraph from "../views/Rms/RmsGraph.vue";
import RmsSettings from "../views/Rms/RmsSettings.vue";
import AutoCreditBack from "../views/Rms/AutoCreditBack.vue";
import ProfitReaches from "../views/Rms/ProfitReaches.vue";
import AccountGroups from "../views/Settings/AccountGroups.vue";
import BrokerAccount from "../views/Settings/BrokerAccount.vue";
import CryptoAddress from "../views/Settings/CryptoAddress.vue";
import EmailAddress from "../views/Settings/EmailAddress.vue";
import GeneralInfo from "../views/Settings/GeneralInfo.vue";
import KycSetAccess from "../views/Settings/KycSetAccess.vue";
import LeverageView from "../views/Settings/LeverageView.vue";
import PaymentMethods from "../views/Settings/PaymentMethods.vue";
import ServerConfiguration from "../views/Settings/ServerConfiguration.vue";
import TermsCondition from "../views/Settings/TermsCondition.vue";
import CurrencyConvart from "../views/Settings/CurrencyConvart.vue";
import SupportView from "../views/Support/SupportView.vue";
import ClosedTrades from "../views/Trades/ClosedTrades.vue";
import ShortDurationTrades from "../views/Trades/ShortDurationTrades.vue";
import LiveTrades from "../views/Trades/LiveTrades.vue";
import TopPerformedIb from "../views/TopPerformedIb/TopPerformedIbView.vue";
import TrxCreditIn from "../views/Transactions/TrxCreditIn.vue";
import TrxCreditOut from "../views/Transactions/TrxCreditOut.vue";
import TrxDeposit from "../views/Transactions/TrxDeposit.vue";
import TrxSummery from "../views/Transactions/TrxSummery.vue";
import TrxTransfer from "../views/Transactions/TrxTransfer.vue";
import TrxWithdraw from "../views/Transactions/TrxWithdraw.vue";
import TradeMaster from "../views/TradeMaster/TradeMaster.vue";
import TradeMasterInvestorView from "../views/Mam/TradeMasterInvestorView.vue";
import TradableBonusHistory from "@/views/TradableBonus/TradableBonusHistory.vue";
import ManagerCommissionHistory from "@/views/MamWallet/ManagerCommissionHistory.vue";
import Forbidden from "@/views/403/403.vue";
import AllInvestors from "@/views/Mam/AllInvestors.vue";

import WalletTransactionsHistory from "@/views/MamWallet/WalletTransactionsHistory.vue";
import ManagerWalletInfo from "@/views/MamWallet/ManagerWalletInfo.vue";
import InvestorWalletInfo from "@/views/MamWallet/InvestorWalletInfo.vue";

import LowBalanceAccount from "../views/Rms/LowBalanceAccount.vue";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

function checkUserAuthentication() {
  const token = store.state.authentication.token;

  if (token) {
    const decodedToken = decodeJwt(token);

    if (
      decodedToken &&
      new Date(decodedToken.exp * 1000) > new Date() &&
      new Date(decodedToken.exp * 1000) <
      new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
    ) {
      return true;
    }
  }

  return false;
}

function decodeJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    const payload = JSON.parse(atob(base64));
    return payload;
  } catch (error) {
    return null;
  }
}

const routes = [
  {
    path: "/",
    component: LoginView,
    name: "Login",
    meta: {
      noSidebar: true,
      title: "Login"
    },
  },
  {
    path: "/dashboard",
    component: DashboardView,
    name: "Dashboard",
    meta: { requiresAuth: true, title: "Dashboard" },
  },
  {
    path: "/403",
    component: Forbidden,
    name: "Forbidden",
    meta: { requiresAuth: true, title: "No Page Found" },
  },
  {
    path: "/profile-verify",
    component: ProfileVerify,
    name: "ProfileVerify",
    meta: { requiresAuth: true, title: "Profile Verify" },
  },
  {
    path: "/live-trading-account",
    component: LiveTradingAccount,
    name: "LiveTradingAccount",
    meta: { requiresAuth: true, title: "Live Trading Account" },
  },
  {
    path: "/partner-list",
    component: PartnerList,
    name: "PartnerList",
    meta: { requiresAuth: true, title: "Partner List" },
  },
  {
    path: "/top-performed-ib",
    name: "TopPerformedIb",
    component: TopPerformedIb,
    meta: { title: "Top Performed IB" },
  },
  {
    path: "/partner-list-details",
    component: PartnerListDetails,
    name: "PartnerListDetails",
    meta: { requiresAuth: true, title: "Partner List Details" },
  },
  {
    path: "/documents",
    component: DocumentsView,
    name: "DocumentsView",
    meta: { requiresAuth: true, title: "Documents" },
  },
  {
    path: "/demo-trading-account",
    component: DemoTradingAccount,
    name: "DemoTradingAccount",
    meta: { requiresAuth: true, title: "Demo Trading Account" },
  },
  {
    path: "/commission-settings",
    component: CommissionSettings,
    name: "CommissionSettings",
    meta: { title: "Commission Settings" }
  },
  {
    path: "/commission-tree",
    component: CommissionTree,
    name: "CommissionTree",
    meta: { title: "Commission Tree" }
  },
  {
    path: "/assign-account-type",
    component: AssignAccountType,
    name: "AssignAccountType",
    meta: { title: "Assign Account Type" }
  },
  {
    path: "/withdraw-requests",
    component: WithdrawRequests,
    name: "WithdrawRequests",
    meta: { title: "Withdraw Requests" }
  },
  {
    path: "/registered-user",
    name: "registered-user",
    component: RegisteredUser,
    meta: { requiresAuth: true, title: "Registered User" },
  },
  {
    path: "/low-balance-account",
    name: "LowBalanceAccount",
    component: LowBalanceAccount,
    meta: {
      requiresAuth: true,
      title: "loW Balance account"
    },
  },
  {
    path: "/registered-user-details/:id",
    name: "RegisteredUserDetails",
    component: RegisteredUserDetails,
    meta: { requiresAuth: true, title: "Registered User Details" },
  },
  {
    path: "/create-new-user-account",
    name: "create-new-user-account",
    component: CreateNewUserAccount,
    meta: { requiresAuth: true, title: "Create New User Account" },
  },
  {
    path: "/user-activity",
    name: "user-activity",
    component: UserActivity,
    meta: { requiresAuth: true, title: "User Activity" },
  },

  {
    path: "/banner-upload",
    name: "BannerUpload",
    component: BannerUpload,
    meta: { requiresAuth: true, title: "Banner Upload" },
  },

  {
    path: "/currency",
    name: "CurrencyView",
    component: CurrencyView,
    meta: { requiresAuth: true, title: "Currency View" },
  },
  {
    path: "/transaction-history",
    name: "TrxSummery",
    component: TrxSummery,
    meta: { title: "Transaction history" }
  },
  {
    path: "/deposit",
    name: "TrxDeposit",
    component: TrxDeposit,
    meta: { title: "Deposit" }
  },
  {
    path: "/withdraw",
    name: "TrxWithdraw",
    component: TrxWithdraw,
    meta: { title: "Withdraw" }
  },
  {
    path: "/internal-transctions",
    name: "TrxTransfer",
    component: TrxTransfer,
    meta: { title: "Transfer" }
  },
  {
    path: "/credit-in",
    name: "TrxCreditIn",
    component: TrxCreditIn,
    meta: { title: "Credit In" }
  },
  {
    path: "/credit-out",
    name: "TrxCreditOut",
    component: TrxCreditOut,
    meta: { title: "Credit Out" }
  },
  {
    path: "/live-trades",
    name: "LiveTrades",
    component: LiveTrades,
    meta: { title: "Live Trades" }
  },
  {
    path: "/closed-trades",
    name: "ClosedTrades",
    component: ClosedTrades,
    meta: { title: "Closed Trades" }
  },
  {
    path: "/short-duration-trades",
    name: "ShortDurationTrades",
    component: ShortDurationTrades,
    meta: { title: "Short Duration Trades" }
  },
  {
    path: "/managers",
    name: "ManagersView",
    component: ManagersView,
    meta: { title: "Managers" }
  },
  {
    path: "/investors",
    name: "InvestorsView",
    component: InvestorsView,
    meta: { title: "Investors" }
  },
  // {
  //   path: "/all-investors",
  //   name: "InvestorsView",
  //   component: InvestorsView,
  //   meta: { title: "All Investors" }
  // },
  {
    path: "/manager-statistics",
    name: "ManagerStatistics",
    component: ManagerStatistics,
    meta: { title: "Manager Statistics" }
  },
  {
    path: "/manager-details",
    name: "ManagerDetails",
    component: ManagerDetails,
    meta: { title: "Manager Details" }
  },
  {
    path: "/trade-master",
    name: "TradeMaster",
    component: TradeMaster,
    meta: { title: "Trade Master" },
  },
  {
    path: "/trade-master-investors",
    name: "TradeMasterDetails",
    component: TradeMasterInvestorView,
    meta: { title: "Trade Master Investor Details" },
  },
  {
    path: "/rms-settings",
    name: "RmsSettings",
    component: RmsSettings,
    meta: { title: "RMS Settings" }
  },
  {
    path: "/rms-graph",
    name: "RmsGraph",
    component: RmsGraph,
    meta: { title: "RMS Graph" }
  },
  {
    path: "/auto-credit-back",
    name: "AutoCreditBack",
    component: AutoCreditBack,
    meta: { title: "Auto Credit Back" }
  },
  {
    path: "/profit-reaches",
    name: "ProfitReaches",
    component: ProfitReaches,
    meta: { title: "Profit Reaches" }
  },
  {
    path: "/news",
    name: "NewsView",
    component: NewsView,
    meta: { title: "News" }
  },
  {
    path: "/add-news",
    name: "AddNews",
    component: AddNews,
    meta: { title: "Add News" }
  },
  {
    path: "/support",
    name: "SupportView",
    component: SupportView,
    meta: { title: "Support" }
  },
  {
    path: "/import-excel",
    name: "ImportExcel",
    component: ImportExcel,
    meta: { title: "Import Excel" }
  },
  {
    path: "/edit-news/:id",
    name: "NewsEdit",
    component: NewsEdit,
    props: true,
    meta: { title: "Edit News" }
  },
  {
    path: "/send-email",
    name: "SendEmail",
    component: SendEmail,
    meta: { title: "Send Email" }
  },
  {
    path: "/server-configuration",
    name: "ServerConfiguration",
    component: ServerConfiguration,
    meta: { title: "Server Configuration" }
  },
  {
    path: "/email-address",
    name: "EmailAddress",
    component: EmailAddress,
    meta: { title: "Email Address" }
  },
  {
    path: "/general-info",
    name: "GeneralInfo",
    component: GeneralInfo,
    meta: { title: "General Info" }
  },
  {
    path: "/leverage",
    name: "LeverageView",
    component: LeverageView,
    meta: { title: "Leverage" }
  },
  {
    path: "/account-groups",
    name: "AccountGroups",
    component: AccountGroups,
    meta: { title: "Account Groups" }
  },
  // {
  //   path: "/payment-methods",
  //   name: "PaymentMethods",
  //   component: PaymentMethods,
  //   meta: { title: "Payment Methods" }
  // },
  {
    path: "/broker-account",
    name: "BrokerAccount",
    component: BrokerAccount,
    meta: { title: "Broker Account" }
  },
  {
    path: "/crypto-address",
    name: "CryptoAddress",
    component: CryptoAddress,
    meta: { title: "Crypto Address" }
  },
  {
    path: "/kyc-set-access",
    name: "KycSetAccess",
    component: KycSetAccess,
    meta: { title: "KYC Access" }
  },
  {
    path: "/admin-list",
    name: "AdminList",
    component: AdminList,
    meta: { title: "Admin Lists" }
  },
  {
    path: "/login-records",
    name: "LoginRecords",
    component: LoginRecords,
    meta: { title: "Login Records" }
  },
  // {
  //   path: "/contest",
  //   name: "ContestView",
  //   component: ContestView,
  //   meta: { title: "Contest" }
  // },
  {
    path: "/join-request",
    name: "JoinRequest",
    component: JoinRequest,
    meta: { title: "Join Request" }
  },
  // {
  //   path: "/pending-contest",
  //   name: "PendingContest",
  //   component: PendingContest,
  //   meta: { title: "Pending Contest" }
  // },
  // {
  //   path: "/running-contest",
  //   name: "RunningContest",
  //   component: RunningContest,
  //   meta: { title: "Running Contest" }
  // },
  // {
  //   path: "/finished-contest",
  //   name: "FinishedContest",
  //   component: FinishedContest,
  //   meta: { title: "Finished Contest" }
  // },
  {
    path: "/email-history",
    name: "EmailHistory",
    component: EmailHistory,
    meta: { title: "Email History" }
  },
  {
    path: "/inactive-accounts",
    name: "InactiveAccounts",
    component: InactiveAccounts,
    meta: { title: "Inactive Accounts" }
  },
  {
    path: "/email-logs",
    name: "EmailLogs",
    component: EmailLogs,
    meta: { title: "Email Logs" }
  },
  {
    path: "/terms-and-condition",
    name: "TermsCondition",
    component: TermsCondition,
    meta: { title: "Terms Condition" }
  },
  {
    path: "/currency-usd-to-inr",
    name: "CurrencyConvart",
    component: CurrencyConvart,
    meta: { title: "Currency Convart" }
  },
  {
    path: "/level-unlock-settings",
    name: "LevelUnlockSettings",
    component: LevelUnlockSettings,
    meta: { title: "Level Unlock Settings" }
  },
  {
    path: "/tradable-bonus-history", 
    name: "TradableBonusHistory",
    component: TradableBonusHistory,
    meta: { title: "Tradable Bonus" }
  },
  {
    path:"/manager-commission-history",
    name:"ManagerCommissionHistory",
    component:ManagerCommissionHistory,
    meta:{title:"Managers Commission History"}
  },
  {
    path: "/wallet-transactions-history",
    name: "WalletTransactionsHistory",
    component: WalletTransactionsHistory,
    meta: { title: "Wallet Transactions History" }
  },
  {
    path: "/managers-wallet-info",
    name: "ManagerWalletInfo",
    component: ManagerWalletInfo,
    meta: { title: "Manager Wallet Info" }
  },
   {
    path: "/investors-wallet-info",
    name: "InvestorWalletInfo",
    component: InvestorWalletInfo,
    meta: { title: "Investor Wallet Info" }
  },
   {
    path: "/all-investors",
    name: "AllInvestors",
    component: AllInvestors,
    meta: { title: "All Investors" }
  },

];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`
  const isAuthenticated = checkUserAuthentication();

  if (isAuthenticated) {
    if (to.path === "/") {
      next("/dashboard");
    } else {
      next();
    }
  } else {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      next("/");
    } else {
      next();
    }
  }
});

export default router;
